<template>
	<div class="culture">
		<p>COMPANY PROFILE</p>
		<h3>公司文化</h3>
		<div class="container">
			<div class="content clearfix">
				<div style="font-size:13px" v-html="cultrue"></div>
			</div>
		
		</div>
		
	</div>
</template>

<script>
	export default{
		name:'',
		components:{},
		data(){
			return{
				msg:'culture',
				cultrue:'',
			}
		},
		methods:{
			getData(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.cultrueApi,
				})
				.then((res) => {
					this.cultrue = res.data.data;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){
			this.getData();
			$('.content img').each(function(){
				$(this).attr('width','100%').css('width','100%');
				console.log(this);
			});
		},
		mounted(){
			$('.content img').each(function(){
				$(this).attr('width','100%').css('width','100%');
				console.log(this);
			});
		}
	}
</script>

<style lang="less">
@import url("../../../../styles/main.less");
.culture{
	P{
		.margin-top(50);
		.font-size(30);
		color: #00A0FF;
		text-align:center;
	}
	h3{
		.margin-top(10);
		.font-size(30);
		font-weight: 600;
		.margin-bottom(50);
		text-align:center;
	}
	.content{
		.margin-top(20);
		p{
			text-align:left;
			.font-size(30);
			color:#444;
		}
		img{
			width:100% !important;
			height:auto !important;
		}
	}
}

</style>


// WEBPACK FOOTER //
// src/components/pages/About/Acom/Culture.vue